import { useTranslation } from 'react-i18next';

export default function ArticlePreview() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium uppercase tracking-wider mb-3">
              SEO Guide
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 tracking-tight">
              {t('article_title')}
            </h2>
          </div>

          <div className="bg-white rounded-xl border border-background-200/60 overflow-hidden hover:shadow-lg transition-shadow duration-300">
            <div className="grid grid-cols-1 md:grid-cols-5">
              <div className="md:col-span-2 aspect-video md:aspect-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20digital%20spreadsheet%20fashion%20ecommerce%20data%20analysis%20minimalist%20workspace%20laptop%20screen%20showing%20product%20catalog%20clean%20aesthetic%20warm%20lighting%20editorial%20photography%20premium%20lifestyle&width=600&height=400&seq=article-img-01&orientation=landscape"
                  alt={t('article_title')}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="md:col-span-3 p-5 md:p-7 flex flex-col justify-center">
                <p className="text-xs font-medium text-foreground-400 uppercase tracking-wider mb-2">
                  {t('article_meta')}
                </p>
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3">
                  {t('article_title')}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  {t('article_excerpt')}
                </p>
                <a
                  href="/article/allchinabuy-spreadsheet-guide"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors self-start cursor-pointer"
                >
                  {t('article_read_more')}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}